<template>
  <component :is="component" />
</template>

<script>
import quotaCheck from '../components/quotaCheck.vue'
import quotaEdit from '../quotaEdit.vue'
export default {
  components: {
    quotaCheck,
    quotaEdit
  },
  data() {
    return {
      component: 'quotaCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'quotaCheck' : 'quotaEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order-manage/check/quotaCheck.vue